import React from 'react';

import { ListItemIcon } from 'components';

type Props = {
  icon: React.ElementType;
  size?: number;
};

export const ItemIcon: React.FC<Props> = ({ icon: Icon, size = 25 }) => (
  <ListItemIcon
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      '&.MuiListItemIcon-root': { minWidth: size },
      borderRadius: '3px',
      background:
        'linear-gradient(135deg, rgba(251,225,93,0.2), rgba(243,156,18,0.2))',
      mr: 1,
    }}
  >
    <Icon sx={{ fontSize: size / 2, color: 'primary.main' }} />
  </ListItemIcon>
);
